import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { ReactivationRequest, UpdateOrderRequest } from '@atlassian/cssxp-typescommon';
import { v4 as generateUuid } from 'uuid';

const client = createAxiosClient({ baseURL: '/api/1/pls' }, ServiceProxyMap.ANS);

export const validateAndReactivatePLSEntitlement = async (requestPayload: UpdateOrderRequest): Promise<any> => {
  const requestBody = constructRequest(requestPayload);

  const responseValidate = await validatePOAEntitlment(requestBody);
  let responseActivate;
  if (responseValidate.status === 200) {
    responseActivate = await activatePOAEntitlment(requestBody);
  }
  return responseValidate;
};

export const validatePOAEntitlment = async (requestBody: ReactivationRequest) => {
  const response = await client.post('/reactivation/pls/validation', requestBody);
  return response;
};

export const activatePOAEntitlment = async (requestBody: ReactivationRequest) => {
  try {
    const response = await client.post('/reactivation/pls/activation', requestBody);
    return response;
  } catch (err) {
    return {
      error: err,
      status: 400,
    };
  }
};

const constructRequest = (requestPayload: UpdateOrderRequest) => {
  const request_id = generateUuid();
  const requestBody: ReactivationRequest = {
    arguments: {
      provision_request_id: request_id,
    },
    resources: [],
    resource_packages: [
      {
        offering_id: requestPayload.offeringId ?? '',
        resources: {
          refs: [],
          ids: [`ari:cloud:platform::site/${requestPayload.cloudSiteId}`],
        },
      },
    ],
  };
  return requestBody;
};
